var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 20.25C2.41421 20.25 2.75 20.5858 2.75 21V31.25H31.25V21C31.25 20.5858 31.5858 20.25 32 20.25C32.4142 20.25 32.75 20.5858 32.75 21V32C32.75 32.4142 32.4142 32.75 32 32.75H2C1.58579 32.75 1.25 32.4142 1.25 32V21C1.25 20.5858 1.58579 20.25 2 20.25Z",
    fill: "#6e6f77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 1.25C17.4142 1.25 17.75 1.58579 17.75 2V22.6893L23.4697 16.9697C23.7626 16.6768 24.2374 16.6768 24.5303 16.9697C24.8232 17.2626 24.8232 17.7374 24.5303 18.0303L17.5303 25.0303C17.2374 25.3232 16.7626 25.3232 16.4697 25.0303L9.46967 18.0303C9.17678 17.7374 9.17678 17.2626 9.46967 16.9697C9.76256 16.6768 10.2374 16.6768 10.5303 16.9697L16.25 22.6893V2C16.25 1.58579 16.5858 1.25 17 1.25Z",
    fill: "#6e6f77"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.4968cb0d8eefab3230d6339160d2ab41.svg";
export { ForwardRef as ReactComponent };